import React from "react";
import { object, func, array, bool, string } from "prop-types";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, Button } from "react-bootstrap";
import classNames from "classnames";

import { logout, addCampaign, addVideo, setPassword, hideModalPassword } from "../actions";

// pages
import Backlog from "../components/Backlog";
import Users from "../components/pages/Users/index";
import Devices from "../components/pages/Devices/index";
import UsersToExclude from "../components/pages/UsersToExclude/index";

import Panel from "../components/Panel";
import Header from "../components/Header";
import CampaignList from "../components/CampaignList";
import CampaignView from "../components/CampaignView";
import CampaignAdd from "../components/CampaignAdd";
import CampaignStats from "../components/CampaignStats";
import VideoAdd from "../components/VideoAdd";
import ABTest from "../components/ABTest";
import ModalPasswordForm from "../components/ModalPasswordForm";
import Submenu from "../components/Submenu";
import AccountReport from "../components/AccountReport";
import Workflow from "../components/Workflow";
import CampaignSending from "../components/CampaignSending";
import CampaignSendingManager from "../components/CampaignSendingManager";
import BrandChannel from "../components/BrandChannel";
import MailingViewer from "../components/pages/Mailing/MailingViewer";
import MailingManager from "../components/pages/Mailing/MailingManager";

const Campaigns = ({
  activeAccount,
  accounts,
  location,
  userEmail,
  campaigns,
  match,
  logout,
  submitAddCampaign,
  submitAddVideo,
  isAuthViaToken,
  submitSetPassword,
  showPasswordSetSuccess,
  showModalPassword,
  hideModalPassword,
  userId,
  timeframeChooser,
  user
}) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={match.url}
          render={() => {
            return (
              <div>
                <Panel campaigns={campaigns} logout={logout} />
                <Submenu />
                <CampaignList campaigns={campaigns} activeAccount={activeAccount} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/add`}
          render={({ match }) => {
            return (
              <div>
                <Panel campaigns={campaigns} logout={logout} />
                <Header title="Nova campanha" />
                <CampaignAdd onSubmit={submitAddCampaign} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/videos`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <CampaignView campaign={campaign} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/stats`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <CampaignStats
                  location={location}
                  campaign={campaign}
                  timeframeChooser={timeframeChooser}
                  user={user}
                />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/video/:videoId/abtest`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <ABTest video={video} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/video/:videoId/workflow`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <Workflow video={video} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/video/:videoId/sending`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <Header title="Novo envio" />
                <CampaignSending video={video} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/video/:videoId/sending-manager`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <Header title="Listagem de envios" />
                <CampaignSendingManager video={video} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/video/:videoId/brand-channel`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <Header title="Criação de Brand Channel" />
                <BrandChannel campaign={campaign} video={video} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/addVideo`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} />
                <Header title="Upload de video" />
                <VideoAdd
                  campaignId={campaign.id}
                  onSubmit={video => {
                    submitAddVideo(video, campaign.id);
                  }}
                />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/videos/:videoId/mailing-viewer`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <Header title="Envio de Mailing" />
                <MailingViewer campaign={campaign} video={video} />
              </div>
            );
          }}
        />

        <Route
          exact
          path={`${match.url}/:campaignId/videos/:videoId/mailing-manager`}
          render={({ match }) => {
            let campaign = _.find(campaigns, { id: match.params.campaignId });
            let video = _.find(campaign.videos, { id: match.params.videoId });
            return (
              <div>
                <Panel campaigns={campaigns} campaign={campaign} logout={logout} submenu />
                <Header title="Gerência de Mailing" />
                <MailingManager campaign={campaign} video={video} />
              </div>
            );
          }}
        />
      </Switch>

      <Route
        exact
        path={`${match.url}/reports`}
        render={() => {
          return (
            <div>
              <Panel campaigns={campaigns} logout={logout} />
              <Submenu />
              <AccountReport campaigns={campaigns} timeframeChooser={timeframeChooser} />
            </div>
          );
        }}
      />

      <Route
        exact
        path={`${match.url}/backlog/itau`}
        render={() => {
          return (
            <div>
              <Panel campaigns={campaigns} logout={logout} />
              <Submenu />
              <Backlog />
            </div>
          );
        }}
      />

      <Route
        exact
        path={`${match.url}/users`}
        render={() => {
          return (
            <div>
              <Panel campaigns={campaigns} logout={logout} />
              <Submenu />
              <Users />
            </div>
          );
        }}
      />

      <Route
        exact
        path={`${match.url}/devices`}
        render={() => {
          return (
            <div>
              <Panel campaigns={campaigns} logout={logout} />
              <Submenu />
              <Devices />
            </div>
          );
        }}
      />

      <Route
        exact
        path={`${match.url}/:campaignId/video/:videoId/users-to-exclude`}
        render={({ match }) => {
          let campaign = _.find(campaigns, { id: match.params.campaignId });
          let video = _.find(campaign.videos, { id: match.params.videoId });
          return (
            <div>
              <Panel campaigns={campaigns} logout={logout} />
              <Submenu />
              <UsersToExclude video={video} />
            </div>
          );
        }}
      />

      <Modal show={showModalPassword}>
        <Modal.Header>
          <Modal.Title>Acesse os resultados</Modal.Title>
        </Modal.Header>
        <Modal.Body className="clearfix">
          <div
            className={classNames({
              hidden: showPasswordSetSuccess
            })}
          >
            <p>Crie uma senha para acessar os relatórios.</p>
            <ModalPasswordForm
              onSubmit={passwordGroup => {
                submitSetPassword(passwordGroup, userId);
              }}
            />
          </div>
          <div
            className={classNames({
              hidden: !showPasswordSetSuccess
            })}
          >
            <p>Cadastro efetuado com sucesso.</p>
            <p>
              O e-mail de login registrado foi: <strong>{userEmail}</strong>
            </p>
            <p>Acesse os relatórios diariamente e obtenha insights para as próximas campanhas, aproveite!</p>
          </div>
        </Modal.Body>
        <Modal.Footer
          className={classNames({
            hidden: !showPasswordSetSuccess
          })}
        >
          <Button
            onClick={() => {
              hideModalPassword();
            }}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

Campaigns.propTypes = {
  activeAccount: object,
  accounts: array,
  location: object,
  user: object,
  logout: func,
  campaigns: array,
  match: object,
  submitAddCampaign: func,
  submitAddVideo: func,
  isAuthViaToken: bool,
  showPasswordSetSuccess: bool,
  showModalPassword: bool,
  hideModalPassword: func,
  submitSetPassword: func,
  userId: string,
  userEmail: string,
  timeframeChooser: object
};

const mapStateToProps = (state, props) => {
  return {
    activeAccount: state.app.activeAccount,
    accounts: state.app.accounts,
    campaigns: state.app.activeAccount.campaigns,
    isAuthViaToken: state.app.isAuthViaToken,
    showPasswordSetSuccess: state.app.showPasswordSetSuccess,
    showModalPassword: state.app.showModalPassword,
    userId: state.app.user.id,
    userEmail: state.app.user.email,
    timeframeChooser: state.timeframechooser,
    user: state.app.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    submitAddCampaign: campaign => {
      dispatch(addCampaign(campaign));
    },
    submitAddVideo: (video, campaignId) => {
      dispatch(addVideo(video, campaignId));
    },
    logout: () => {
      dispatch(logout());
    },
    submitSetPassword: (passwordGroup, userId) => {
      dispatch(setPassword(passwordGroup, userId));
    },
    hideModalPassword: () => {
      dispatch(hideModalPassword());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);



// WEBPACK FOOTER //
// ./src/containers/Campaigns.js